<template>
  <div id="q-app">
    <div>
      <q-stepper v-model="step" ref="stepper" color="primary" animated>
        <q-step
          :name="1"
          :title="getTitle()"
          :icon="'img:' + require('@/assets/img/lapiz-copy-3.svg')"
          :done="step > 1"
        >
          <Planificacion
            v-if="tipoIndicador==='cualitativo'"
            :instrumentoPlan="dataIndicadorInstrumentoPlan"
            :isLoading="isLoading"
            :optionSelected ="optionSelected"
            @updateDataIndicador="fillDataIndicador"
            :isManual="isManual"
          />

          <div v-if="tipoIndicador === 'satelital'" class="row">
            <div class="col-4" style="padding-left: 5px;">
                <GraficaMunicipioIndicador
                v-if="grafica.hasOwnProperty('valoresGrafica')"
                :dataIndicador="dataIndicadorGrafica"
                showLittleTag
                disableOpenURL />
            </div>
          </div>

          <DatosPartidaYObjetivo
            v-if="tipoIndicador==='cuantitativo' || (tipoIndicador==='satelital' && grafica.hasOwnProperty('valoresGrafica'))"
            :datosPartidaYObjetivo="dataIndicadorDatosPartidaYObjetivo"
            @updateDataDatosPartidaYObjetivo="fillDatosPartidaYObjetivo"
            :tipoIndicador="tipoIndicador === 'satelital'? 'satelital' : 'cuantitativo'"
            :isManual="isManual"
          />
        </q-step>

        <q-step
          :name="2"
          title="Acciones"
          :icon="'img:' + require('@/assets/img/edit-calendar-black-24-dp.svg')"
          :done="step > 2"
        >
          <ListadoAccionesNuevas
            :isLoading="isLoading"
            :acciones="dataIndicadorAcciones"
            :optionSelected ="optionSelected"
            @updateDataIndicadorAcciones="fillDataIndicadorAcciones"
            :isManual="isManual"
          />
        </q-step>

        <q-step
          :name="3"
          title="Acciones asociadas"
          :icon="'img:' + require('@/assets/img/clip1.svg')"
        >

          <ListadoAccionesAsociadas
            :isLoading="isLoading"
            :accionesAsociadas="dataIndicadorAccionesAsociadas"
            :idIndicador ="getIdIndicator()"
            :tipoIndicador="tipoIndicador"
            :optionSelected ="optionSelected"
            @updateDataIndicadorAccionesAsociadas="fillDataIndicadorAccionesAsociadas"
            :isManual="isManual"
          />
        </q-step>

        <template v-slot:navigation>
          <q-stepper-navigation>
            <div class="left">
              <q-btn
                flat
                class="bCancel"
                @click="cancel()"
                label="Cancelar"
              ></q-btn>
            </div>
            <div class="rigth">
              <q-btn
                v-if="step > 1"
                flat
                class="bCancel"
                @click="previous()"
                label="Atrás"
              ></q-btn>
              <q-btn
                @click="next()"
                class="bPrincipal"
                :disabled="checkDisabled()"
                :label="step === 3 ? 'Guardar' : 'Continuar'"
                :loading="step === 3 ? isLoadingSave : false"
                :style="isOnlyAccess && step === 3?'display: none': ''"
              ></q-btn>
            </div>
          </q-stepper-navigation>
        </template>
      </q-stepper>
    </div>
    <DialogDelete
      v-model="showDialogDelete"
      dataCy="delete-indicador"
      :showIcon="false"
      :txtContainer="
        `Si cancela se perderán los cambios no guardados ¿Desea continuar?`
      "
      labelDelete="SÍ, CONTINUAR"
      @save="cancelEdit()"
    />
  </div>
</template>
<script>
import { QStep, QStepper, QStepperNavigation } from 'quasar';
import Planificacion from '@/components/PlanAccion/components/Planificacion.vue';
import DatosPartidaYObjetivo from '@/components/PlanAccion/components/DatosPartidaYObjetivo.vue';
import ListadoAccionesNuevas from '@/components/PlanAccion/components/ListadoAccionesNuevas.vue';
import ListadoAccionesAsociadas from '@/components/PlanAccion/components/ListadoAccionesAsociadas.vue';
import * as types from '@/storeModules/NGUD/types';
import DialogDelete from '@/shared/dialogs/delete/DialogDelete.vue';
import { mapGetters } from 'vuex';
import moment from 'moment';
import GraficaMunicipioIndicador from '@/components/Indicadores/components/GraficaMunicipioIndicador.vue';

export default {
  components: {
    QStep,
    QStepper,
    QStepperNavigation,
    Planificacion,
    DialogDelete,
    ListadoAccionesNuevas,
    ListadoAccionesAsociadas,
    DatosPartidaYObjetivo,
    GraficaMunicipioIndicador
  },
  props: {
    dataIndicador: Object,
    dataIndicadorGrafica: Object,
    isLoading: Boolean,
    tipoIndicador: String,
    optionSelected: Object,
    isManual: Boolean
  },
  computed: {
    ...mapGetters({
      objetivoEspecifico: 'NGUD/objetivoEspecifico',
      ciudadSelected: 'NGUD/ciudadData',
      isOnlyAccess: 'NGUD/isOnlyAccess'
    })
  },
  data () {
    return {
      step: 1,
      dataIndicadorInstrumentoPlan: {},
      dataIndicadorDatosPartidaYObjetivo: {},
      dataIndicadorAcciones: [],
      dataIndicadorAccionesAsociadas: [],
      isLoadingSave: false,
      showDialogDelete: false,
      grafica: {}
    };
  },
  created () {
    this.idIndicadorManual = this.dataIndicador.idIndicador;
    this.fillData();
  },
  watch: {
    dataIndicador () {
      this.fillData();
    },
    dataIndicadorGrafica () {
      this.grafica = this.dataIndicadorGrafica;
    }
  },
  methods: {
    getIdIndicator () {
      if (this.isManual) {
        return this.dataIndicador.idIndicador;
      } else {
        return this.tipoIndicador === 'satelital' ? this.dataIndicador.idIndicador : this.dataIndicador.idIndicadorAUE;
      }
    },
    getTitle () {
      if (this.tipoIndicador === 'cualitativo') {
        return this.optionSelected.name === 'Sí' ? 'Planes/Instrumentos de planificación' : 'Compromisos';
      } else {
        return 'Datos de Partida y Objetivo';
      }
    },
    fillData () {
      if (this.dataIndicador) {
        this.dataIndicadorInstrumentoPlan = this.dataIndicador.instrumentoPlanIndicadorAUE;
        this.dataIndicadorDatosPartidaYObjetivo = this.dataIndicador.datosPartidaYObjetivo;
        this.dataIndicadorAcciones = this.dataIndicador.acciones;
        this.dataIndicadorAccionesAsociadas = this.dataIndicador.accionesAsociadas;
      }
    },
    cancel () {
      this.showDialogDelete = true;
    },
    cancelEdit () {
      this.showDialogDelete = false;
      this.$eventHub.$emit('cleanForm');
      this.$emit('updateCancel');
    },
    next () {
      if (this.step < 3) {
        this.step++;
      } else {
        this.saveDataIndicador();
      }
      this.$emit('updateStep', this.step);
    },
    previous () {
      this.step--;
      this.$emit('updateStep', this.step);
    },
    checkDisabled () {
      if (this.isManual) {
        return false;
      }
      let disabled = true;
      if (this.tipoIndicador === 'cualitativo') {
        disabled = this.checkOptionSelected();
      } else if (this.tipoIndicador === 'cuantitativo' || this.tipoIndicador === 'satelital') {
        disabled = this.checkDatosPartidaYObjetivo();
      }
      return disabled;
    },
    checkDatosPartidaYObjetivo () {
      if (this.dataIndicadorDatosPartidaYObjetivo !== undefined) {
        if (this.step === 1) {
          return !(this.dataIndicadorDatosPartidaYObjetivo.datoPartida !== null && this.dataIndicadorDatosPartidaYObjetivo.datoPartida !== '') ||
          !(this.dataIndicadorDatosPartidaYObjetivo.fechaDatoPartida !== undefined && this.dataIndicadorDatosPartidaYObjetivo.fechaDatoPartida !== null && this.dataIndicadorDatosPartidaYObjetivo.fechaDatoPartida !== '') ||
          !(this.dataIndicadorDatosPartidaYObjetivo.datoObjetivo !== null && this.dataIndicadorDatosPartidaYObjetivo.datoObjetivo !== '') ||
          !(this.dataIndicadorDatosPartidaYObjetivo.fechaDatoObjetivo !== undefined && this.dataIndicadorDatosPartidaYObjetivo.fechaDatoObjetivo !== null && this.dataIndicadorDatosPartidaYObjetivo.fechaDatoObjetivo !== '') ||
          !(this.dataIndicadorDatosPartidaYObjetivo.periodicidad.length > 0) ||
          !(this.dataIndicadorDatosPartidaYObjetivo.unidadMedida !== null && this.dataIndicadorDatosPartidaYObjetivo.unidadMedida !== '');
        } else if (this.step === 3) {
          return this.checkAccion();
        }
      } else {
        return false;
      }
    },
    checkOptionSelected () {
      let resp = true;
      if (this.optionSelected.name === 'Sí') {
        resp = this.checkPlan();
      } else {
        resp = this.checkCompromiso();
        if (this.step === 3) {
          resp = (this.checkAccion() || this.checkCompromiso());
        }
      }
      return resp;
    },
    checkPlan () {
      return !(this.dataIndicadorInstrumentoPlan !== undefined &&
      this.dataIndicadorInstrumentoPlan.hasOwnProperty('planes') &&
      this.dataIndicadorInstrumentoPlan.planes.length > 0);
    },
    checkCompromiso () {
      if (this.dataIndicadorInstrumentoPlan !== undefined) {
        return !(this.dataIndicadorInstrumentoPlan.compromisos !== null && this.dataIndicadorInstrumentoPlan.compromisos !== '');
      }
    },
    checkAccion () {
      return !((this.dataIndicadorAcciones !== undefined &&
      this.dataIndicadorAcciones.length > 0) ||
      (this.dataIndicadorAccionesAsociadas !== undefined &&
      this.dataIndicadorAccionesAsociadas.length > 0));
    },
    fillDataIndicador (dataIndicador) {
      this.dataIndicadorInstrumentoPlan = dataIndicador;
      this.$eventHub.$emit('dirtyForm');
    },
    fillDatosPartidaYObjetivo (dataIndicador) {
      this.dataIndicadorDatosPartidaYObjetivo = dataIndicador;
      this.$eventHub.$emit('dirtyForm');
    },
    fillDataIndicadorAcciones (dataIndicador) {
      this.dataIndicadorAcciones = dataIndicador;
      this.$eventHub.$emit('dirtyForm');
    },
    fillDataIndicadorAccionesAsociadas (dataIndicador) {
      this.dataIndicadorAccionesAsociadas = dataIndicador;
      this.$eventHub.$emit('dirtyForm');
    },
    async saveDataIndicador () {
      this.isLoadingSave = true;
      if (this.tipoIndicador === 'cualitativo' && this.optionSelected.name === 'Sí' && this.dataIndicadorInstrumentoPlan.planes && this.dataIndicadorInstrumentoPlan.planes.length > 0) {
        await this.saveFiles();
      }
      let dataIndicador = this.prepareData();
      this.saveData(dataIndicador);
    },
    prepareData () {
      if (!this.dataIndicadorAcciones === undefined) {
        this.dataIndicadorAcciones = [];
      }
      this.deletePositionAcciones();
      this.checkdeleteIntrumentoPlan();
      this.addAccionesAsociadas();
      this.formatDateToPost();
      let dataIndicador = {
        idCiudad: this.dataIndicador.idCiudad,
        idObjetivoEspecifico: this.objetivoEspecifico.id,
        instrumentoPlanIndicadorAUE: this.dataIndicadorInstrumentoPlan,
        acciones: this.dataIndicadorAcciones.length > 0 ? this.dataIndicadorAcciones : [],
        accionesAsociadas: this.dataIndicadorAccionesAsociadas !== undefined && this.dataIndicadorAccionesAsociadas.length > 0 ? this.dataIndicadorAccionesAsociadas : [],
        respuesta: this.optionSelected !== undefined && this.optionSelected.name !== 'No'
      };

      if (this.isManual) {
        dataIndicador['idIndicador'] = this.dataIndicador.idIndicador;
      } else {
        dataIndicador['idIndicadorAUE'] = this.dataIndicador.idIndicadorAUE;
      }

      if (this.tipoIndicador === 'satelital') {
        if (this.dataIndicador.hasOwnProperty('id')) {
          dataIndicador['id'] = this.dataIndicador.id;
        }
        dataIndicador['idIndicador'] = this.dataIndicador.idIndicador;
        delete dataIndicador['idIndicadorAUE'];
      }

      dataIndicador = this.cleanCualitativo(dataIndicador);
      return dataIndicador;
    },
    deletePositionAcciones () {
      if (this.dataIndicadorAcciones.length > 0) delete this.dataIndicadorAcciones[0].position;
    },
    checkdeleteIntrumentoPlan () {
      if (this.optionSelected !== undefined && this.optionSelected.name === 'No') {
        this.dataIndicadorInstrumentoPlan.planes = [];
        if (this.dataIndicadorInstrumentoPlan.hasOwnProperty('listadoDeDeclaraciones')) this.dataIndicadorInstrumentoPlan.listadoDeDeclaraciones = [];
      }
    },
    addAccionesAsociadas () {
      if (this.dataIndicadorAccionesAsociadas !== undefined && this.dataIndicadorAccionesAsociadas.length > 0) {
        this.dataIndicadorAccionesAsociadas.forEach(accionAsociada => {
          accionAsociada.lineasDeActuacion = accionAsociada.arrayLineasActuacionAdded;
          delete accionAsociada.arrayLineasActuacionAdded;
        });
      }
    },
    formatDateToPost () {
      if (this.dataIndicadorDatosPartidaYObjetivo !== undefined) {
        const { fechaDatoObjetivo, fechaDatoPartida } = this.dataIndicadorDatosPartidaYObjetivo;
        if (fechaDatoObjetivo) {
          this.dataIndicadorDatosPartidaYObjetivo.fechaDatoObjetivo = moment(new Date(fechaDatoObjetivo)).format('YYYY-MM-DD');
        } else {
          this.dataIndicadorDatosPartidaYObjetivo.fechaDatoObjetivo = null;
        }
        if (fechaDatoPartida) {
          this.dataIndicadorDatosPartidaYObjetivo.fechaDatoPartida = moment(new Date(fechaDatoPartida)).format('YYYY-MM-DD');
        } else {
          this.dataIndicadorDatosPartidaYObjetivo.fechaDatoPartida = null;
        }
      }
    },
    cleanCualitativo (dataIndicador) {
      if (this.tipoIndicador !== 'cualitativo') {
        dataIndicador['datosPartidaYObjetivo'] = this.dataIndicadorDatosPartidaYObjetivo;
      }
      return dataIndicador;
    },
    saveData (dataIndicador) {
      this.$store
        .dispatch(types.ACTION_SAVE_INDICADORAUE, {
          idCiudad: this.ciudadSelected.id,
          dataIndicador: dataIndicador
        })
        .then((response) => {
          let object = { idRelacion: response.data.id, id: this.dataIndicador.idIndicador, isManual: this.isManual };
          if (this.tipoIndicador === 'satelital') {
            this.$emit('updateListadoSatelitales', object);
          }
          if (this.tipoIndicador === 'cualitativo' && this.optionSelected.name === 'Sí' && this.dataIndicadorInstrumentoPlan.planes && this.dataIndicadorInstrumentoPlan.planes.length > 0) {
            let idIndicador = this.dataIndicador.idIndicadorAUE;
            if (this.isManual) {
              idIndicador = this.dataIndicador.idIndicador;
            }
            this.$emit('updatePlanes', { id: idIndicador, expand: true, isManual: this.isManual });
          }
          if (this.tipoIndicador === 'cualitativo' || this.tipoIndicador === 'cuantitativo') {
            this.$emit('updateIndicadores', object);
          }
          this.isLoadingSave = false;
          this.$eventHub.$emit('cleanForm');
        })
        .catch(() => {
          this.isLoadingSave = false;
        });
    },
    async saveFiles () {
      let arrayPromesas = [];
      this.dataIndicadorInstrumentoPlan.planes.forEach(async plan => {
        // si tiene fichero adjunto sin id -> guardar fichero
        if (plan.filePlanAdjunto && (plan.planAdjuntoId === undefined || plan.planAdjuntoId === '')) {
          arrayPromesas.push(this.$store.dispatch(types.ACTION_SAVE_INDICADOR_DOCUMENTOPDF, { file: { Documento: plan.filePlanAdjunto } }).then((response) => {
            plan.planAdjuntoId = response;
          }));
        }
      });
      const value = Promise.all(arrayPromesas);
      return value;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .q-stepper {
    -webkit-box-shadow: none;
    box-shadow: none;
    border-radius: none;
    margin-top: 15px;
    .q-stepper__step-inner {
      padding: 24px 0px;
    }
    .q-stepper__dot {
      width: 50px;
      height: 50px;
      padding: 12px 13px 14px;
    }
    .q-stepper__tab {
      color: #d8d8d8;
    }
    .q-stepper__tab--active,
    .q-stepper__tab--done {
      color: #00c7da;
    }
    .q-stepper__title {
      color: #727272;
    }
  }
  .q-stepper__tab {
    padding-left: 0px;
    font-family: DINPro;
    font-size: 15px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.11px;
  }
  .q-stepper__nav {
    padding-right: 0px;
    padding-left: 0px;
  }
  .q-stepper__header {
    border: none;
  }
  img {
    height: 16px;
    width: 16px;
  }
}
.rigth {
  float: right;
}
.left {
  float: left;
}
</style>
